import { useEffect } from "react";
import { FaSearch } from "react-icons/fa";

export default function SearchField({ search, setSearch, allStatus, setAllStatus, initialStatuses,setInitialStatuses }) {

    useEffect(() => {
        if(search === ""){
            setAllStatus(initialStatuses);
            return
        }else{
            if(search){
                const filteredStatuses = allStatus&& allStatus.length&&allStatus.filter((status) =>
                    status.toLowerCase().includes(search.toLowerCase())
                );
                setAllStatus(filteredStatuses);
            }
        }
        
    }, [search]);

    return (
        <div className="relative w-auto max-w-md m-[10px] my-[20px]">
            <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" size={14} />
            <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search by status"
                className="w-full pl-10 pr-4 py-2 border border-[#C8D6E6] rounded-md focus:outline-none  text-[#87909E] text-[16px] font-mont font-[400]"
            />
        </div>
    );
}
